module.exports = __webpack_public_path__ + "img/logo-club-allegiance-text.dce851a2.png";